<template>
    <div class="page93Info" id="aboutUs">
        <div class="pageContent">
            <TopLogoBar logoColor="white" textColor="#fff" title="Innovare per realizzare il futuro" :isInHome="true" />
            <div class="container infoContainer">
                <div class="columns">
                    <div class="column is-5 is-offset-1">
                        <p class="descriptionText">
                            <b>page93® realizza e sviluppa sistemi informatici.</b><br>
                            Sceglie sempre soluzioni tecnologiche avanzate su misura per
                            ogni tipo di esigenza per il bene delle imprese.<br>
                            Produce e gestisce sistemi e pacchetti informatici a servizio delle
                            aziende.<br>
                            Sviluppa e assiste soluzioni verticali informatiche per l’efficienza
                            aziendale.<br><br>
                            Il settore di ricerca e sviluppo di page93® è tra i più innovativi in
                            Italia; i prodotti e i servizi offerti sono il risultato di un’evoluzione
                            continua e il sistema di gestione è garanzia assoluta per
                            rinnovare la propria azienda.<br><br>
                            page93® è sinonimo di <b>velocità</b>, <b>dinamicità</b> e <b>innovazione</b>,
                            ma soprattutto <b>personalizzazione</b> e <b>servizio costante.</b>
                            <br><br>
                            <b>page93® è la garanzia per avere servizi intelligenti,
                                sicuri e su misura per la propria azienda.</b>
                        </p>
                    </div>
                    <div class="column is-4 is-offset-1">
                        <p class="contacts">
                            <b class="sectionTitle">CONTACTS:</b>
                            <span class="divider"></span>
                            Sede di Alba:<br>
                            c.so Piera Cillario 6-8
                            12051, Alba (cn)<br>
                            <a href="tel:+39017333662">tel. +39 0173 33662</a>
                            fax +39 0173 365784<br>
                            <span class="divider"></span>
                            <a href="mailto:info@page93.it">info@page93.it</a>
                            <span class="divider"></span>
                            P.IVA 01426850051
                            <br><br>
                            <a @click="$router.push('assistance')" class="is-uppercase" style="color: #eb222b; font-weight: 900;">Teleassistenza</a>
                            <a href="https://www.page93.it/download/politica_qualita_rev_00.pdf" target="_blank" class="is-uppercase" style="color: #eb222b; font-weight: 900;">Politica della qualità</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopLogoBar from '@/components/TopLogoBar'
    export default {
        name: 'Info',
        props: [],
        components: {
            TopLogoBar
        },
    }
</script>

<style scoped lang="scss">
    .page93Info {
        min-height: 100vh;
        position: relative;
        background-color: #000;
        color: #fff;

        &::before {
            content: '';
           // background: url("../assets/images/infoPageBg.jpg") no-repeat;
            //background: url("https://images.pexels.com/photos/1587014/pexels-photo-1587014.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260") no-repeat;

            background: url("../assets/images/bginfo.jpg");

            background-size: cover;
            background-position: center center;
            position: absolute;
            height: 100%;
            width: 100%;
            filter: blur(5px);
        }

        .pageContent {
            width: 100%;
            height: 100%;
            position: relative;
                overflow: hidden;

            .infoContainer {
                display: flex;
                height: 100%;
                //padding: 20px;

                @media only screen and (max-width: 768px) {
                    padding: 20px;
                }
            }

            .descriptionText {
                font-size: 1.2rem;
                font-weight: 400;
                text-align: left;

                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                }
            }

            .contacts {
                font-size: 1.2rem;
                font-weight: 400;

                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;

                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                    align-items: flex-end;
                    text-align: right;
                }

                .divider {
                    height: 3px;
                    width: 100px;
                    display: block;
                    background-color: #fff;
                    margin-top: 5px;
                    margin-bottom: 5px;
                }

                .sectionTitle {
                    font-weight: 500;
                    font-size: 1.3rem;
                }

                a {
                    color: #fff;
                }
            }
        }
    }
</style>